export enum FeeRuleType {
  FLAT_RATE = 'FLAT_RATE',
  PERCENTAGE = 'PERCENTAGE',
}

export enum PackageType {
  NONE = 'NONE',
  FLEX_PLAN = 'FLEX_PLAN',
  BASIC_PLAN = 'BASIC_PLAN',
  PRO_PLAN = 'PRO_PLAN',
  ELA = 'ELA',
  ESSENTIALS = 'ESSENTIALS',
  ESSENTIALS_PLUS = 'ESSENTIALS_PLUS',
}

export enum FeePackageFrontendType {
  FLEX = 'Flex',
  BASIC = 'Basic',
  PRO = 'Pro',
  ELA = 'ELA',
  ESSENTIALS = 'Essentials',
  ESSENTIALS_PLUS = 'Essentials+',
  NONE = 'None',
}

export enum PackageScope {
  GLOBAL = 'GLOBAL',
  COMPANY = 'COMPANY',
}

export enum FeePaidBy {
  SITE_HOST = 'SITE_HOST',
  DRIVER = 'DRIVER',
}

export interface FeeRule {
  id: string;
  type: FeeRuleType;
  amount?: number;
  amounts?: Array<{
    currency: string;
    value: number;
  }>;
  percentage?: number;
  paidBy: FeePaidBy;
}

export interface FeePackage {
  id: string;
  type: PackageType;
  currency: string;
  feeRules: FeeRule[];
}

export interface FeePackagesResponse {
  totalCount: number;
  entities: FeePackage[];
}
